import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const HorseshoeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 64 64">
    {/* Main U horseshoe with square ends, shifted up */}
    <path
      d="
        M18 2
        Q10 16 12 34
        Q14 52 32 52
        Q50 52 52 34
        Q54 16 46 2
        L54 4
        Q62 18 58 38
        Q54 58 32 58
        Q10 58 6 38
        Q2 18 10 4
        L18 2
        Z
      "
      fill="#8B5C2A"
      stroke="#5C3B17"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    {/* Inner path for hollow effect, shifted up */}
    <path
      d="
        M22 8
        Q15 19 17 34
        Q19 48 32 48
        Q45 48 47 34
        Q49 19 42 8
      "
      fill="none"
      stroke="#A8763E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    {/* Nail holes - left, shifted up */}
    <circle cx="16" cy="20" r="1.5" fill="#5C3B17" />
    <circle cx="15" cy="30" r="1.5" fill="#5C3B17" />
    <circle cx="18" cy="40" r="1.5" fill="#5C3B17" />
    {/* Nail holes - right, shifted up */}
    <circle cx="48" cy="20" r="1.5" fill="#5C3B17" />
    <circle cx="49" cy="30" r="1.5" fill="#5C3B17" />
    <circle cx="46" cy="40" r="1.5" fill="#5C3B17" />
    {/* Square ends: short rectangles, shifted up */}
    <rect x="8" y="2" width="12" height="6" rx="2" fill="#8B5C2A" stroke="#5C3B17" strokeWidth="2" />
    <rect x="44" y="2" width="12" height="6" rx="2" fill="#8B5C2A" stroke="#5C3B17" strokeWidth="2" />
  </SvgIcon>
);

export default HorseshoeIcon;
